import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function Home() {
	return (
		<>
			<Helmet>
				<title>Apex Specialty Contracting LLC | Roofing & Storm Restoration – Tarpon Springs, FL</title>
				<meta name="description" content="Apex Specialty Contracting LLC provides expert roofing replacement, storm damage repair, and insurance claims assistance in Tarpon Springs, FL and the Tampa Bay area. Free estimates. Call (916) 316-0696." />
				<script type="application/ld+json">{JSON.stringify({
					'@context': 'https://schema.org',
					'@type': 'RoofingContractor',
					name: 'Apex Specialty Contracting LLC',
					legalName: 'APEX SPECIALTY CONTRACTING LLC',
					url: 'https://appexconnecthub.com/',
					telephone: '+19163160696',
					email: 'info@appexconnecthub.com',
					address: {
						'@type': 'PostalAddress',
						streetAddress: '183 Highland Rd',
						addressLocality: 'Tarpon Springs',
						addressRegion: 'FL',
						postalCode: '34689',
						addressCountry: 'US'
					},
					areaServed: ['Tarpon Springs, FL', 'Tampa, FL', 'Clearwater, FL', 'St. Petersburg, FL', 'New Port Richey, FL'],
					openingHoursSpecification: {
						'@type': 'OpeningHoursSpecification',
						dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday'],
						opens: '07:00',
						closes: '18:00'
					},
					sameAs: ['https://www.facebook.com/', 'https://www.instagram.com/', 'https://www.linkedin.com/']
				})}</script>
			</Helmet>

			{/* Hero */}
			<section className="hero" style={{ position: 'relative', overflow: 'hidden', backgroundImage: 'url(https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=1800&auto=format&fit=crop)', backgroundSize: 'cover', backgroundPosition: 'center 40%' }}>
				<div className="hero-overlay" />
				<div className="container">
					<div className="hero-grid">
						<div className="hero-content fade-up">
							<p className="helper" style={{ margin: '0 0 6px', fontSize: 13, letterSpacing: 1, textTransform: 'uppercase' }}>Licensed &amp; Insured · Tarpon Springs, FL</p>
							<h1 style={{ marginTop: 4 }}>Tampa Bay's Trusted Roofing &amp; Storm Restoration Experts</h1>
							<p>
								When storms hit or your roof needs attention, Apex Specialty Contracting is your local expert. We handle everything from inspections and repairs to full replacements and insurance claims — with honest pricing and no surprises.
							</p>
							<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
								<Link className="btn" to="/contact">Get a Free Estimate</Link>
								<a className="btn-outline" href="tel:9163160696">(916) 316-0696</a>
							</div>
							<p className="helper" style={{ marginTop: 6, fontSize: 12 }}>
								By requesting a quote you may receive SMS updates. Msg/data rates may apply. Reply STOP to opt out. Reply HELP for help.
							</p>
							<div className="badges" style={{ marginTop: 10 }}>
								<span className="badge">Licensed &amp; Insured</span>
								<span className="badge">Free Roof Inspections</span>
								<span className="badge">Insurance Claims Help</span>
								<span className="badge">Storm Ready</span>
							</div>
						</div>
						<div className="fade-up" style={{ animationDelay: '120ms' }}>
							<div className="card" style={{ padding: 24 }}>
								<h3 style={{ marginTop: 0, marginBottom: 4 }}>Request a Free Estimate</h3>
								<p className="helper" style={{ margin: '0 0 14px', fontSize: 13 }}>We'll inspect your roof and give you an honest quote — no pressure, no obligation.</p>
								<ul className="helper" style={{ marginTop: 8, paddingLeft: 16 }}>
									<li>Roof replacement &amp; repair</li>
									<li>Storm &amp; hail damage assessment</li>
									<li>Insurance claim walk-through</li>
									<li>Gutter installation &amp; repair</li>
								</ul>
								<Link className="btn" to="/contact" style={{ marginTop: 14, display: 'inline-block' }}>Schedule Inspection</Link>
								<p className="helper" style={{ marginTop: 10, fontSize: 12 }}>
									Call us: <a href="tel:9163160696" style={{ color: 'inherit' }}>(916) 316-0696</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Trust bar */}
			<section className="trustbar">
				<div className="container" style={{ display: 'flex', gap: 24, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
					<p className="helper" style={{ margin: 0 }}>Serving homeowners and businesses in the Tampa Bay area since 2021</p>
					<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
						<span className="pill">✓ Licensed Contractor</span>
						<span className="pill">✓ Fully Insured</span>
						<span className="pill">✓ Free Estimates</span>
						<span className="pill">✓ 5-Year Workmanship Warranty</span>
					</div>
				</div>
			</section>

			{/* Services Overview */}
			<section className="section">
				<div className="container">
					<div style={{ textAlign: 'center', marginBottom: 28 }}>
						<h2>Our Roofing Services</h2>
						<p className="helper" style={{ maxWidth: 560, margin: '0 auto' }}>From minor repairs to full roof replacements, we do it all with craftsmanship and care.</p>
					</div>
					<div className="grid grid-3 features">
						<div className="card feature fade-up">
							<div className="icon-circle">
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12L12 3l9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 10v9a1 1 0 0 0 1 1h4v-5h4v5h4a1 1 0 0 0 1-1v-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
							</div>
							<h3>Roof Replacement</h3>
							<p className="helper">Complete tear-off and replacement with premium asphalt shingles, metal, tile, or flat roofing systems tailored to your home and budget.</p>
							<Link to="/services" className="card-link">Learn More →</Link>
						</div>
						<div className="card feature fade-up" style={{ animationDelay: '80ms' }}>
							<div className="icon-circle">
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 2.5c0 1.5-1.5 7-1.5 7h-2C10.5 9.5 9 4 9 2.5a2.5 2.5 0 0 1 5 0Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9v13M9 12H4a1 1 0 0 0-.96.72l-1 3.5A1 1 0 0 0 3 17.5V21h18v-3.5a1 1 0 0 0-.04-.28l-1-3.5A1 1 0 0 0 19 13h-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
							</div>
							<h3>Storm Damage Repair</h3>
							<p className="helper">Fast response after hurricanes, hail, and high-wind events. We document all damage, perform emergency tarping, and handle the full repair or replacement.</p>
							<Link to="/services" className="card-link">Learn More →</Link>
						</div>
						<div className="card feature fade-up" style={{ animationDelay: '160ms' }}>
							<div className="icon-circle">
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.5"/><path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
							</div>
							<h3>Insurance Claims Assistance</h3>
							<p className="helper">Our team works directly with your insurance adjuster, provides detailed damage reports, and advocates for your claim to get you the settlement you deserve.</p>
							<Link to="/services" className="card-link">Learn More →</Link>
						</div>
						<div className="card feature fade-up" style={{ animationDelay: '80ms' }}>
							<div className="icon-circle">
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5"/><path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
							</div>
							<h3>Free Roof Inspection</h3>
							<p className="helper">Our certified inspectors assess the condition of your roof, identify problem areas, and provide a transparent written report with no obligation to proceed.</p>
							<Link to="/services" className="card-link">Learn More →</Link>
						</div>
						<div className="card feature fade-up" style={{ animationDelay: '140ms' }}>
							<div className="icon-circle">
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9h18M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" stroke="currentColor" strokeWidth="1.5"/><path d="M8 9V7a4 4 0 0 1 8 0v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
							</div>
							<h3>Gutter Installation &amp; Repair</h3>
							<p className="helper">Protect your foundation and landscaping with properly installed seamless gutters, downspouts, gutter guards, and complete drainage solutions.</p>
							<Link to="/services" className="card-link">Learn More →</Link>
						</div>
						<div className="card feature fade-up" style={{ animationDelay: '200ms' }}>
							<div className="icon-circle">
								<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M6 7V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="1.5"/><path d="M12 12v4m-2-2h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
							</div>
							<h3>Commercial Roofing</h3>
							<p className="helper">TPO, EPDM, modified bitumen, and metal roofing systems for commercial and industrial properties with minimal disruption to your business operations.</p>
							<Link to="/services" className="card-link">Learn More →</Link>
						</div>
					</div>
				</div>
			</section>

			{/* Why Choose Us */}
			<section className="section section-alt">
				<div className="container two-col">
					<div className="img-frame fade-up">
						<img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=1600&auto=format&fit=crop" alt="Roofing crew inspecting a residential roof" />
					</div>
					<div className="fade-up" style={{ animationDelay: '100ms' }}>
						<h2>Why Homeowners Choose Apex</h2>
						<p className="helper">We've built a reputation across the Tampa Bay area for showing up on time, doing quality work, and standing behind every job we complete.</p>
						<div style={{ marginTop: 18 }}>
							<div className="check-item">
								<div className="check-icon">✓</div>
								<div>
									<strong>Fully Licensed &amp; Insured</strong>
									<p className="helper">We carry full general liability and workers' compensation insurance to protect you and your property.</p>
								</div>
							</div>
							<div className="check-item">
								<div className="check-icon">✓</div>
								<div>
									<strong>5-Year Workmanship Warranty</strong>
									<p className="helper">Every installation and repair comes backed by our workmanship guarantee — if something goes wrong, we fix it at no cost.</p>
								</div>
							</div>
							<div className="check-item">
								<div className="check-icon">✓</div>
								<div>
									<strong>Transparent, Upfront Pricing</strong>
									<p className="helper">No hidden fees, no surprise line items. We provide detailed written estimates before any work begins.</p>
								</div>
							</div>
							<div className="check-item">
								<div className="check-icon">✓</div>
								<div>
									<strong>Responsive Communication</strong>
									<p className="helper">You'll always know where your project stands with SMS updates, direct contact with your project manager, and prompt responses.</p>
								</div>
							</div>
						</div>
						<Link className="btn" to="/about" style={{ marginTop: 20, display: 'inline-block' }}>Learn More About Us</Link>
					</div>
				</div>
			</section>

			{/* Our Process */}
			<section className="section">
				<div className="container">
					<div style={{ textAlign: 'center', marginBottom: 28 }}>
						<h2>Our Simple 4-Step Process</h2>
						<p className="helper" style={{ maxWidth: 520, margin: '0 auto' }}>From your first call to the final inspection, we make roofing easy and stress-free.</p>
					</div>
					<div className="process">
						<div className="step fade-up">
							<div className="circle">1</div>
							<h4>Free Inspection &amp; Estimate</h4>
							<p className="helper">A certified inspector visits your property, assesses the roof, and provides a detailed written estimate — completely free with no obligation.</p>
						</div>
						<div className="step fade-up" style={{ animationDelay: '100ms' }}>
							<div className="circle">2</div>
							<h4>Insurance &amp; Approval</h4>
							<p className="helper">Need to file a claim? We work directly with your insurance company to document damage and ensure you receive the maximum approved benefit.</p>
						</div>
						<div className="step fade-up" style={{ animationDelay: '180ms' }}>
							<div className="circle">3</div>
							<h4>Professional Installation</h4>
							<p className="helper">Our licensed crews execute the project efficiently, keeping your property clean and secure. You'll receive opt-in SMS updates at each milestone.</p>
						</div>
						<div className="step fade-up" style={{ animationDelay: '250ms' }}>
							<div className="circle">4</div>
							<h4>Final Walkthrough &amp; Warranty</h4>
							<p className="helper">We inspect the completed work together, handle final cleanup, provide all documentation, and register your manufacturer and workmanship warranties.</p>
						</div>
					</div>
				</div>
			</section>

			{/* Stats */}
			<section className="section section-alt">
				<div className="container">
					<div className="stats">
						<div className="stat card fade-up">
							<strong>500+</strong>
							<span>Roofs Completed</span>
						</div>
						<div className="stat card fade-up" style={{ animationDelay: '80ms' }}>
							<strong>5★</strong>
							<span>Average Customer Rating</span>
						</div>
						<div className="stat card fade-up" style={{ animationDelay: '160ms' }}>
							<strong>5 Years</strong>
							<span>Workmanship Warranty</span>
						</div>
					</div>
				</div>
			</section>

			{/* Service Area Teaser */}
			<section className="section">
				<div className="container">
					<div style={{ textAlign: 'center', marginBottom: 28 }}>
						<h2>Serving the Tampa Bay Area</h2>
						<p className="helper" style={{ maxWidth: 560, margin: '0 auto' }}>Based in Tarpon Springs, we serve residential and commercial clients throughout Pinellas and Pasco counties.</p>
					</div>
					<div className="grid grid-3">
						<div className="card" style={{ padding: 18, textAlign: 'center' }}><strong>Tarpon Springs</strong><p className="helper">Our home base</p></div>
						<div className="card" style={{ padding: 18, textAlign: 'center' }}><strong>Clearwater</strong><p className="helper">Pinellas County</p></div>
						<div className="card" style={{ padding: 18, textAlign: 'center' }}><strong>St. Petersburg</strong><p className="helper">Pinellas County</p></div>
						<div className="card" style={{ padding: 18, textAlign: 'center' }}><strong>Tampa</strong><p className="helper">Hillsborough County</p></div>
						<div className="card" style={{ padding: 18, textAlign: 'center' }}><strong>New Port Richey</strong><p className="helper">Pasco County</p></div>
						<div className="card" style={{ padding: 18, textAlign: 'center' }}><strong>Palm Harbor</strong><p className="helper">Pinellas County</p></div>
					</div>
					<div style={{ textAlign: 'center', marginTop: 24 }}>
						<Link to="/industries" className="btn-outline">View All Service Areas →</Link>
					</div>
				</div>
			</section>

			{/* CTA */}
			<section className="section cta-section">
				<div className="container" style={{ textAlign: 'center' }}>
					<h2>Ready to Protect Your Home?</h2>
					<p className="helper" style={{ maxWidth: 520, margin: '0 auto 20px' }}>Don't wait for a small problem to become a big one. Contact our team today for a free, no-obligation inspection and estimate.</p>
					<div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
						<Link className="btn" to="/contact">Request a Free Estimate</Link>
						<a className="btn-outline" href="tel:9163160696">Call (916) 316-0696</a>
					</div>
				</div>
			</section>
		</>
	);
}

export default Home;
